import { createSelector } from "reselect";
import get from "lodash/get";
import find from "lodash/find";
import {
  paymentModeSelector,
  orderSelector,
  planServiceSelector,
  formattedSelectedNumberSelector,
  sessionTokenSelector,
  paymentFormSelector,
  selectedDeviceSelector
} from "ducks/selectors";
import { paths, BRAND_NAME, PHONE_PAYMENT_OPTIONS } from "utils/constants";
import { getChannelFromUrl } from "utils/helpers";

const orderSummaryDomain = state =>
  get(state, "form.OrderSummaryForm.values", {});

const wireCardPaymentDomain = state =>
  get(state, "form.WireCardOneTimePaymentForm.values", {});

export const orderSummarySelector = createSelector(
  orderSummaryDomain,
  orderSummary => orderSummary
);

export const WireCardOneTimePaymentSelector = createSelector(
  wireCardPaymentDomain,
  wireCard => wireCard
);

export const makeSelectOrderSummaryForm = () => orderSummarySelector;

export const makeSelectWireCardOneTimePaymentForm = () =>
  WireCardOneTimePaymentSelector;

export const makeSelectOrderSummaryFormInitialValues = () =>
  createSelector(paymentModeSelector, paymentModes => {
    const defaultPaymentMode =
      find(paymentModes, paymentMode => {
        return paymentMode.default;
      }) || {};

    return {
      terms_of_service_agreed: true,
      critical_info_consent: false,
      payment_method: defaultPaymentMode
    };
  });

export const makeSelectOrderSummaryPayload = () =>
  createSelector(
    orderSummarySelector,
    orderSelector,
    planServiceSelector,
    formattedSelectedNumberSelector,
    sessionTokenSelector,
    paymentFormSelector,
    selectedDeviceSelector,
    (
      orderSummary,
      order,
      planDetails,
      formattedSelectedNumber,
      sessionToken,
      paymentForm,
      selectedDevice
    ) => {
      const { code, channel_code } =
        get(paymentForm, "payment_method") ||
        get(orderSummary, "payment_method") ||
        {};
      let payment_methods = { code, channel_code };
      const order_id = get(order, "order_ref", "");
      const planName = get(planDetails, "textName", BRAND_NAME);
      const selectedNumber = get(formattedSelectedNumber, "formattedNumber");
      let description = `${planName} - ${selectedNumber} #${order_id}`;
      const channel = getChannelFromUrl();
      const origin = window.location.origin;
      const status_path = paths.PAYMENT_STATUS.replace(":channel", channel);
      let status_url = `${origin}${status_path}?order_ref=${order_id}&token=${sessionToken}`;

      // override parameters for IPP
      if (selectedDevice?.paymentType === PHONE_PAYMENT_OPTIONS.IPP) {
        const return_path = paths.PAYMENT_RETURN.replace(":channel", channel);
        status_url = `${origin}${return_path}?order_ref=${order_id}&token=${sessionToken}`;
        description = `Circles.Life - #${order_id} - ${selectedDevice?.paymentTerm} months installment payment for ${selectedDevice?.label}`;
        payment_methods = {
          code: ["ipp"],
          additional_data: {
            description,
            installments: [selectedDevice?.paymentTerm],
            success_redirect_url: status_url,
            failure_redirect_url: status_url,
            return_url: status_url
          }
        };
      }

      return {
        order_id,
        description,
        payment_methods,
        success_redirect_url: status_url,
        failure_redirect_url: status_url,
        token: sessionToken
      };
    }
  );
